import { useEffect } from "react";
import { useParams } from "react-router-dom";
import Comentario from "../../../Comentarios";
import { NoticiaDetalhesProps } from "../../../Pages/AconteceNaForluz/Detalhes";

const Noticias: React.FC<NoticiaDetalhesProps> = ({ noticia }) => {

  const link = useParams();

  useEffect(() => {
    if (noticia?.Title) {
      document.title = "Noticias - " + noticia?.Title;
    }
  }, [noticia]);

  function renderObjectBody(data: any) {
    return { __html: data }
  }
  return (
    <>
      <div className="_the-content page-extrato pt-lg-6 pb-10">
        <div className='container'>
          <div className="row justify-content-center">
            <div className="col-lg-10">
              {noticia &&

                <div className="content">

                  {noticia.Corpo &&
                    <> <span dangerouslySetInnerHTML={renderObjectBody(noticia.Corpo)} />

                      <hr></hr> </>}

                  {noticia.Extra &&
                    <><span dangerouslySetInnerHTML={renderObjectBody(noticia.Extra)} /><hr className="my-7"></hr></>
                  }
                </div>
              }
              <Comentario link={link.id} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Noticias;


